import { createXHRGrpcWebTransport } from './xhr-grpc-web-transport';
import { useSessionStore } from '@/store';

const interceptors = [];

const injectSession = (next) => async (request) => {
  const session = useSessionStore();
  const token = await session.getToken();

  token && request.header.set('Authorization', `Bearer ${token}`);
  return next(request);
};

if (typeof window.__CONNECT_WEB_DEVTOOLS__ === 'function') {
  interceptors.push(window.__CONNECT_WEB_DEVTOOLS__);

  window.addEventListener('connect-web-dev-tools-ready', () => {
    interceptors.push(window.__CONNECT_WEB_DEVTOOLS__);
  });
}

interceptors.push(injectSession);

export const transport = createXHRGrpcWebTransport({
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  interceptors,
});
